// 8-point compass label for a FROM-direction in degrees (mirrors WeatherStrip).
export function compassFrom(deg: number, locale: string): string {
  const dirs =
    locale === 'zh'
      ? ['北', '东北', '东', '东南', '南', '西南', '西', '西北']
      : ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']
  const idx = Math.round((((deg % 360) + 360) % 360) / 45) % 8
  return dirs[idx]!
}
